import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const CustomIcon = React.forwardRef(function CustomIcon({ icon, fill, ...otherProps }: any, ref) {
    return (
        <SvgIcon {...otherProps} ref={ref}>
            <g fill={fill ?? "currentColor"}>{icon}</g>
        </SvgIcon>
    );
});

export default CustomIcon;
